/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Language_Select_PlaceholderInputs */



/**
* | output |
* | --- |
* | "-- Select a language --" |
*
* @param {Knp_Guide_Language_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_language_select_placeholder = /** @type {((inputs?: Knp_Guide_Language_Select_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Language_Select_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("-- Sélectionner une langue --")
	if (locale === "de") return /** @type {LocalizedString} */ ("-- Wählen Sie eine Sprache --")
	if (locale === "it") return /** @type {LocalizedString} */ ("-- Seleziona una lingua --")
	if (locale === "ru") return /** @type {LocalizedString} */ ("-- Выберите язык --")
	if (locale === "es") return /** @type {LocalizedString} */ ("-- Seleccione un idioma --")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("-- 选择语言 --")
	if (locale === "ja") return /** @type {LocalizedString} */ ("-- 言語を選択 --")
	if (locale === "hi") return /** @type {LocalizedString} */ ("-- भाषा चुनें --")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("-- Selecione um idioma --")
	return /** @type {LocalizedString} */ ("-- Select a language --")
});